import { authSessionProviderSchema } from '@server/domains/oauth/common/dto/provider.schema'
import { COOKIE_KEYS } from '@server/shared/entry'
import { z } from 'zod'

export const authorizationSchema = z.object({
  [COOKIE_KEYS.ACCESS_TOKEN]: z.string(),
  [COOKIE_KEYS.REFRESH_TOKEN]: z.string(),
  [COOKIE_KEYS.USER_UID]: z.string().transform((val) => parseInt(val)),
  [COOKIE_KEYS.USER_TOKEN]: z.string().optional(),
  [COOKIE_KEYS.SESSION_ID]: z.string(),
  [COOKIE_KEYS.OAUTH_PROVIDER_NAME]: authSessionProviderSchema.optional().default('kakao'),
  [COOKIE_KEYS.OAUTH_PROVIDER_ACCESS_TOKEN]: z.string().optional(),
  [COOKIE_KEYS.OAUTH_PROVIDER_REFRESH_TOKEN]: z.string().optional(),
})

export interface UnauthorizedState {
  isAuthorized: false
}
export interface AuthorizedState extends z.infer<typeof authorizationSchema> {
  isAuthorized: true
  bearerToken: string
}
export type AuthorizationState = UnauthorizedState | AuthorizedState

export const LEGACY_LOGGED_IN_KEYS = ['accessToken', 'refreshToken', 'uid', 'token']
